import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useCallback
} from 'react';
import { TranslationContext } from "./useTranslationContext";

const shepherdDsStatusPath = "status/omshepherd/*";

export const ApiConnectionContext = createContext();

export const ApiConnectionContextProvider = ({ children, p }) => {
  const t = useContext(TranslationContext);

  const [ loggedInAs, setLoggedInAs ] = useState(null);
  const [ gatewayName, setGatewayName ] = useState(t('theme:product'));
  const [ lanAddress, setLanAddress ] = useState(null);
  const [ version, setVersion ] = useState(null);
  const [ connected, setConnected ] = useState(true);
  const [ container, setContainer] = useState(null);

  const onLogin = useCallback((username) => {
    setLoggedInAs(username);
    setConnected(true);
  }, [ setConnected, setLoggedInAs ]);

  const onLogout = useCallback(() => {
    setLoggedInAs(null);
  }, [ setConnected, setLoggedInAs ]);

  // Set up listeners
  useEffect(() => {
    p.addListener("connect_error", function () {
      setConnected(false);
    });
    p.addListener("disconnect", function () {
      setConnected(false);
    });
    p.addListener("connect", () => setConnected(true));
    p.onAuthenticated(onLogin);
    p.addListener("not_authenticated", onLogout);

    if (p.isConnected() && !p.isAuthenticated()) {
      onLogout();
    }

    p.subscribePush(shepherdDsStatusPath)
    .then(function() {
      p.subscribeDS("status/omshepherd/gatewayName", (currentName) =>
          setGatewayName(currentName?.v || ""), true);
      p.subscribeDS("status/omshepherd/lanAddress", (newLanAddr) =>
          setLanAddress(newLanAddr?.v || ""), true);

      const { v: shepherdState } = p.getPath("status/omshepherd");
      if (shepherdState) {
        setVersion(shepherdState.version);
        setContainer(shepherdState.container);
      }
    }, (error) => {
      console.error("Cannot load lanAddress", error);
    });
  }, [ p, onLogout, onLogin, setGatewayName, setVersion, setContainer, setLanAddress, version ]);

  const contextValue = {
    connected, container, lanAddress, loggedInAs, gatewayName, p, version,
  };

  return (
      <ApiConnectionContext.Provider value={contextValue}>
        { children }
      </ApiConnectionContext.Provider>
  )
}